import styled from 'styled-components';
import tw from 'twin.macro';

export const ErrorText = styled.p`
  ${tw`mt-2 body-xs text-red-600`}
`;
